"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-six/sections/serviceSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServiceSection366sItem = {
    key: Key | null | undefined;
    /** Detected variants: "shape-one" */
    className?: string;
    /** Detected variants: "shape-two" */
    div1ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/services-icon-1.svg" | "/Templates/Doccure/img/icons/services-icon-2.svg" | "/Templates/Doccure/img/icons/services-icon-3.svg" | "/Templates/Doccure/img/icons/services-icon-4.svg" */
    src: string;
    /** Detected variants: "Pet Consultation" | "Vaccination" | "Grooming" | "Nutrition" */
    h30Text: ReactNode;
    /** Detected variants: "Comprehensive health check ups & expert medical advice for your pets" | "Essential immunizations to protect your pets from common diseases" | "Professional care to keep your pets clean and comfortable" | "Personalized diet plans to support your pet’s healthy growth" */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/service/service-img-1.jpg" | "/Templates/Doccure/img/service/service-img-2.jpg" | "/Templates/Doccure/img/service/service-img-3.jpg" | "/Templates/Doccure/img/service/service-img-4.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "col-lg-3 col-md-6 col-sm-6" */
    divClassName?: string;
    /** Detected variants: "services-item-six" */
    div0ClassName?: string;
    /** Detected variants: "services-icon" */
    div0ClassName2?: string;
    /** Detected variants: "services" */
    alt?: string;
    /** Detected variants: "img-fluid icon-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "services-content" */
    div1ClassName2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "service-img" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid overlay-img" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "" */
    div0div1p0Expr1?: ReactNode;
};
export type HomeSixServiceSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSection366sItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "Services" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Our" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Services" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Veterinary" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "banner-icon" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-7.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    serviceSection366s: ServiceSection366sItem[];
    serviceSection366sItemWrapper?: (item: ServiceSection366sItem, content: ReactNode) => ReactNode;
    serviceSection366sRenderer?: (defaultNode: ReactNode) => ReactNode;
    serviceSection366sImageVisible?: boolean;
    serviceSection366sImageRenderer?: (item: ServiceSection366sItem, defaultNode: ReactNode) => ReactNode;
    serviceSection366sH3Visible?: boolean;
    serviceSection366sH3Renderer?: (item: ServiceSection366sItem, defaultNode: ReactNode) => ReactNode;
    serviceSection366sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    serviceSection366sH3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSection366sItem) => Partial<ComponentProps<"h3">>);
};

const HomeSixServiceSectionGenerated: FC<HomeSixServiceSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Services",
    sectionDiv0Div0H20H2Text = "Our",
    sectionDiv0Div0H20H2Text2 = "Services",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Veterinary",
    sectionImageWithBasePath0ImageAlt = "banner-icon",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/banner-icon-7.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    sectionDiv0Div1ClassName,
    serviceSection366s,
    serviceSection366sItemWrapper,
    serviceSection366sRenderer,
    serviceSection366sImageVisible,
    serviceSection366sImageRenderer,
    serviceSection366sH3Visible,
    serviceSection366sH3Renderer,
    serviceSection366sImageProps,
    serviceSection366sH3Props,
}) => {
    return (
        <section className="services-section-six section">
            <div className="container">
                <div className="section-header-six section-white text-center">
                    <div className="section-sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span className="line-6">{sectionDiv0Div0H20Span0SpanText}</span>
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        serviceSection366s,
                        (item: ServiceSection366sItem) => (
                            <div className={item.divClassName ?? "col-lg-3 col-md-6 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "services-item-six"}>
                                    <div className={item.div0ClassName2 ?? "services-icon"}>
                                        {renderItemNode(serviceSection366sImageVisible, serviceSection366sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "services"} className={item.imageWithBasePath0ClassName ?? "img-fluid icon-1"} {...(typeof serviceSection366sImageProps === "function" ? serviceSection366sImageProps(item) : (serviceSection366sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        <div className={item.className} />
                                        <div className={item.div1ClassName} />
                                    </div>
                                    <div className={item.div1ClassName2 ?? "services-content"}>
                                        {renderItemNode(serviceSection366sH3Visible, serviceSection366sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof serviceSection366sH3Props === "function" ? serviceSection366sH3Props(item) : (serviceSection366sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                    </div>
                                    {renderItemNode(serviceSection366sImageVisible, serviceSection366sImageRenderer, item, (
                                        <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "service-img"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid overlay-img"} {...(typeof serviceSection366sImageProps === "function" ? serviceSection366sImageProps(item) : (serviceSection366sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                </div>
                            </div>
                        ),
                        serviceSection366sItemWrapper,
                        serviceSection366sRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid icon-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSixServiceSectionGenerated;
